import { render, staticRenderFns } from "./CompensationDialog.vue?vue&type=template&id=0fc1a01a&scoped=true"
import script from "./CompensationDialog.vue?vue&type=script&lang=js"
export * from "./CompensationDialog.vue?vue&type=script&lang=js"
import style0 from "./CompensationDialog.vue?vue&type=style&index=0&id=0fc1a01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1a01a",
  null
  
)

export default component.exports